import { LotameClient } from "../../../lotame/LotameClient";
import { Show } from "../../models/Show";

export function sendSponsor(lotameClient: LotameClient): void {
  const show = dataLayerHelper.get<Show>("show");
  const payload = [`Spon=${show?.sponsors ?? ""}`];
  lotameClient.callLotameApiCollect({
    behaviors: {
      act: payload,
    },
  });
}
